<p-dialog
  header="Change Job Details"
  [(visible)]="isShowChangeJobDetails"
  (onHide)="closingDialog()"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
  styleClass="overflow-dialog"
>
  <form [formGroup]="jobDetailsForm" *ngIf="jobDetailsForm" [class.ghost]="!jobInfo">
    <div class="ui-g" style="position: relative">
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Existing capacity end date</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-calendar
            [showTime]="true"
            name="exisingCapacityEndDate"
            styleClass="full-width-calendar"
            dateFormat="D d MM"
            hourFormat="24"
            [disabled]="!(jobInfo?.exisingCapacityEndDate > currentDate())"
            formControlName="exisingCapacityEndDate"
          ></p-calendar>
          <div
            *ngIf="
              !jobDetailsForm.controls['exisingCapacityEndDate'].valid &&
              jobDetailsForm.controls['exisingCapacityEndDate'].dirty &&
              jobDetailsForm.controls['exisingCapacityEndDate'].errors &&
              jobDetailsForm.controls['exisingCapacityEndDate'].errors.error
            "
            class="ui-messages-error ui-corner-all"
            style="padding: 0.25em 0.5em"
          >
            {{ jobDetailsForm.controls['exisingCapacityEndDate'].errors.error }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Released from hold date</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-calendar
            [showTime]="true"
            name="heldEndDate"
            styleClass="full-width-calendar"
            dateFormat="D d MM"
            hourFormat="24"
            formControlName="heldEndDate"
            [disabled]="true"
          ></p-calendar>
          <div
            *ngIf="
              !jobDetailsForm.controls['heldEndDate'].valid &&
              jobDetailsForm.controls['heldEndDate'].dirty &&
              jobDetailsForm.controls['heldEndDate'].errors &&
              jobDetailsForm.controls['heldEndDate'].errors.error
            "
            class="ui-messages-error ui-corner-all"
            style="padding: 0.25em 0.5em"
          >
            {{ jobDetailsForm.controls['heldEndDate'].errors.error }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Grab it now opens date</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-calendar
            [showTime]="true"
            name="exisingCapacityEndDate"
            styleClass="full-width-calendar"
            dateFormat="D d MM"
            hourFormat="24"
            [disabled]="!(jobInfo?.exisingCapacityEndDate < jobInfoEarliestPickUpTime)"
            formControlName="buyNowOpensDate"
          ></p-calendar>
          <div
            *ngIf="
              !jobDetailsForm.controls['buyNowOpensDate'].valid &&
              jobDetailsForm.controls['buyNowOpensDate'].dirty &&
              jobDetailsForm.controls['buyNowOpensDate'].errors &&
              jobDetailsForm.controls['buyNowOpensDate'].errors.error
            "
            class="ui-messages-error ui-corner-all"
            style="padding: 0.25em 0.5em"
          >
            {{ jobDetailsForm.controls['buyNowOpensDate'].errors.error }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Scheduled Date</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-calendar
            [showTime]="false"
            name="scheduledDate"
            styleClass="full-width-calendar"
            dateFormat="D d MM"
            hourFormat="24"
            formControlName="scheduledDate"
          ></p-calendar>
          <div
            *ngIf="
              !jobDetailsForm.controls['scheduledDate'].valid &&
              jobDetailsForm.controls['scheduledDate'].dirty &&
              jobDetailsForm.controls['scheduledDate'].errors &&
              jobDetailsForm.controls['scheduledDate'].errors.error
            "
            class="ui-messages-error ui-corner-all"
            style="padding: 0.25em 0.5em"
          >
            {{ jobDetailsForm.controls['scheduledDate'].errors.error }}
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Grab it now price</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <input
            name="buyItNowPrice"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
            (change)="setHasPriceChanged()"
            formControlName="buyItNowPrice"
          />
        </div>
      </div>
      <div class="ui-g-12" *ngIf="hasPriceChanged">
        <div class="ui-grid-col-6">
          <label>Price Change Reason</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-dropdown
            name="priceChangeReason"
            placeholder="Select a reason"
            [options]="priceChangeReasons"
            [appendTo]="'body'"
            formControlName="priceChangeReason"
            filter="true"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12" *ngIf="isOtherReasonSelected">
        <div class="ui-grid-col-6">
          <label>Price Change Reason Text</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <input
            id="price-change-reason-other"
            type="text"
            pInputText
            formControlName="priceChangeReasonText"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Existing capacity price</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <input
            name="existingCapacityPrice"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
            formControlName="existingCapacityPrice"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Supplier Paid</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <input
            name="supplierPrice"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
            formControlName="supplierPrice"
          />
        </div>
      </div>

      <div *ngIf="jobInfo && !jobInfo.isSelfInsured" class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Insurance Provider</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <p-dropdown
            name="insuranceProviders"
            [options]="insuranceProviders"
            [appendTo]="'body'"
            [style]="{ width: '100%' }"
            formControlName="insuranceProviderId"
          ></p-dropdown>
        </div>
      </div>

      <div *ngIf="jobInfo && !jobInfo.isSelfInsured" class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Insurance Cost</label>
        </div>
        <div class="ui-grid-col-6 ghost-inline">
          <input
            name="insuranceCost"
            [style]="{ width: '100%' }"
            pInputText
            maxlength="10"
            (keydown)="inputHelper.allowNumberInputKey($event)"
            (keyup)="inputHelper.fixDigits($event.target)"
            formControlName="insuranceCost"
          />
        </div>
      </div>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusyChangeJobDetails"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%; width: 50px; height: 50px"
        alt="load"
      />
    </div>
  </form>
  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="cancelChangeJobDetails()"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        [disabled]="!changeJobDetailsValid() || jobDetailsForm.invalid"
        class="ui-button ui-button-primary"
        (click)="saveChangeJobDetails()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
